import axios from "axios";
import { AUTH_TOKEN_KEY, isJwtExpired, isJwtToken, normalizeAuthToken } from "./authToken";
export const LOGIN_ACTION = "[Login Action]";
export const Confirm_Login_Action = "[Confirm Login Action]";

export function clearClientAuth(dispatch, actionType = "LOGOUT") {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem("financeTourSkipped");
    sessionStorage.removeItem("pendingLogin");
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["x-business-id"];
    dispatch({ type: actionType });
}

export function createLoginAction() {
    return { type: LOGIN_ACTION };
}

export function login(payload) {
    const data = {
        email: payload.email,
        password: payload.password,
    };
    console.log(data);
    axios
        .post("v1/users/login", data)
        .then((res) => {
            console.log(res);
            // store.dispatch(confirmloginAction(res))
        })
        .catch((e) => {
            console.log(e);
        });
}
export function loginAction(payload) {
    return (dispatch) => {
        axios.post("v1/users/login", payload).then((res) => {});
        login(payload).then((res) => {
            console.log(res);
            dispatch(confirmloginAction(res.data.data));
        });
    };
}
export function confirmloginAction(response) {
    return { type: Confirm_Login_Action, payload: response };
}

export function COMPLETE_LOGIN(loginData, dispatch) {
    const token = normalizeAuthToken(loginData?.token);
    if (!isJwtToken(token) || isJwtExpired(token)) {
        throw new Error("The login response did not contain a valid authentication token.");
    }

    sessionStorage.removeItem("hasDismissedOutstandingFeeModal");
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    dispatch({ type: "LOGIN", payload: { ...loginData, token } });
}

export function REQUEST_LOGIN(payload) {
    return axios.post("v1/users/login", payload);
}

export function LOGIN_USER(payload, dispatch) {
    return new Promise((resolve, reject) => {
        axios
            .post("v1/users/login", payload)
            .then((res) => {
                resolve(res);
                COMPLETE_LOGIN(res.data.data, dispatch);
            })
            .catch((e) => {
                reject(e);
                console.log(e);
            });
    });
}
export function LOGOUT_USER(payload, dispatch) {
    return new Promise((resolve, reject) => {
        axios
            .post("/v1/users/logout", payload)
            .then((res) => {
                clearClientAuth(dispatch, "LOGOUT");
                resolve(res);
            })
            .catch((e) => {
                clearClientAuth(dispatch, "LOGOUT");
                if (e?.response?.status === 401) {
                    resolve(e?.response);
                    return;
                }
                reject(e);
            });
    });
}
export function CLOSE_ACCOUNT(payload, dispatch) {
    return new Promise((resolve, reject) => {
        // delete('', payload
        axios({
            url: "/v1/users/delete-account",
            data: payload,
            method: "delete",
        })
            .then((res) => {
                clearClientAuth(dispatch, "CLOSE_ACCOUNT");
                resolve(res);
            })
            .catch((e) => {
                reject(e);
                console.log(e);
            });
    });
}
